import React from 'react'
import { connect } from 'react-redux'
import AttractionPromoActions from '../../Redux/AttractionPromoRedux'

class Delete extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _delete = (event) => {
    let data = this.props.uuid
    this.props.delete(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '50vw' }}>
        <header className='title-block'>
          <h1 className='title'>Delete Attraction Promo</h1>
        </header>
        <div className='section'>
          <h5 className='text-center'>
            Confirm deletion of ({ this.props.name }) ?
          </h5>
          <div className='form-group d-flex justify-content-end'>
            <button className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}> Cancel</button>
            <button className='btn btn-danger' onClick={() => this._delete()}> Delete</button>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  delete: (data) => dispatch(AttractionPromoActions.deleteAttractionPromoRequest(data))
})

export default connect(stateToProps, dispatchToProps)(Delete)



// WEBPACK FOOTER //
// ./src/Containers/AttractionPromo/Delete.js